import { Component, Optional, Inject } from '@angular/core';
import { INavigationService } from '@pershing/pershing-core';
import { MatDialogRef } from '@angular/material/dialog';
import { TradingService } from '@pershing/trading-common';
@Component({
    selector: 'ng-exchangeagee-dialog',
    templateUrl: './exchange-agreement-confirmlater-dialog.component.html',
    styleUrls: ['./exchange-agreement-confirmlater-dialog.component.css'],
})
export class ExchangeAgreementConfirmLaterDialogComponent {
    deviceType: string = 'desktop';
    constructor(
        private tradingService: TradingService,
        @Optional() @Inject('AppSettings') appSettings: any,
        private dialogRef: MatDialogRef<ExchangeAgreementConfirmLaterDialogComponent>,
        private navigationService: INavigationService) {
        // this.translationService.addTranslationFolder('@pershing/nxi-ng-miscellaneous', 'node_modules/@pershing/nxi-ng-miscellaneous/src');
        if (!!appSettings.deviceType) {
            this.deviceType = appSettings.deviceType;
        }
    }

    closeDialog() {
        // let fromPage = this.appDataStore.get('FROMPAGEDATA') || this.appDataStore.get('EXCHANGE_AGREE_LASTPAGE') || '/nxi/portfolio/overview';
        // let queryString: any = {};
        // let paramNotReq: boolean = false;
        // if (!!fromPage) {
        //     this.appDataStore.put('EXCHANGE_AGREE_LASTPAGE', '');
        //     fromPage = fromPage.split('#')[0];
        // }
        // if (fromPage === 'order-ticket') {
        //     fromPage = 'nxi/transact/neworder';
        // }
        // if ((this.deviceType === 'mobile') && fromPage.includes('nxi/transact/neworder')) {
        //     fromPage = 'nxi/transact/neworder';
        //     paramNotReq = true;
        // }
        // if (this.route.snapshot.queryParams) {
        //     for (const params in this.route.snapshot.queryParams) {
        //         if (!(params === 'rt')) {
        //             // Object.assign(queryString, eDocsQueryString);
        //             queryString[params] = this.route.snapshot.queryParams[params];
        //         }
        //     }
        // }
        // if (paramNotReq) {
        //     queryString = {};
        //     this.navigationService.setGrandChildPage(null);
        // }
        // document.dispatchEvent(new CustomEvent('portal.gotoview', {
        //     detail: {
        //         gotoPage: fromPage,
        //         gotoParams: queryString
        //     }
        // }));
        this.tradingService.setExchangeAgreementDialogState('exit');
        this.dialogRef.close();
    }
    cancelDialog() {
        this.dialogRef.close('close');
    }
}
